// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3Bnap","label":"CategoryService_label__VDp1C","location":"CategoryService_location__Jwt-s"};